<script setup lang="ts">
import { ref } from 'vue'
import { Activity, ChevronDown, ChevronUp } from 'lucide-vue-next'
import type { Component } from 'vue'
import type { OperatingActivityItem } from './types'

withDefaults(
  defineProps<{
    items: OperatingActivityItem[]
    title?: string
    subtitle?: string
    icon?: Component
    iconColor?: string
  }>(),
  {
    title: 'Operating Activity',
    subtitle: 'income, expenses, and interest',
    icon: () => Activity,
    iconColor: '#a78bfa',
  },
)

const expanded = ref(true)
</script>

<template>
  <div data-component="VOperatingActivity">
    <button class="flex w-full cursor-pointer items-center gap-3 py-2.5 text-left" @click="expanded = !expanded">
      <div
        class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full"
        :style="{ backgroundColor: iconColor + '1A' }"
      >
        <component :is="icon" :size="18" :style="{ color: iconColor }" />
      </div>
      <div class="flex-1">
        <div class="text-sm font-semibold text-gray-800">{{ title }}</div>
        <div class="text-xs text-gray-500">{{ subtitle }}</div>
      </div>
      <component :is="expanded ? ChevronUp : ChevronDown" :size="16" class="text-gray-500" />
    </button>
    <div v-show="expanded" class="ml-12 grid grid-cols-2 gap-x-8 gap-y-3 pb-2.5">
      <div v-for="item in items" :key="item.label" class="flex items-center justify-between">
        <div class="flex items-center gap-1.5">
          <div class="h-3 w-3 rounded" :style="{ backgroundColor: item.color }" />
          <span class="text-xs text-gray-500">{{ item.label }}</span>
        </div>
        <span class="text-xs font-semibold text-gray-700">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>
